<template>
  <div class="p-6">
    <h1 class="mb-8 font-extrabold text-4xl text-gray-800">Dashboard</h1>

    <!-- Client Status Statistics -->
    <div class="w-full mt-10 bg-white rounded-lg p-6 flex flex-col lg:flex-row gap-6">
      <div class="w-full lg:w-2/3">
        <h2 class="w-full font-semibold text-center uppercase text-xl text-gray-700 mb-4">Client Status Statistiken</h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div
            v-for="status in clientStatuses"
            :key="status.status"
            class="text-center p-4 bg-blue-50 border border-blue-200 rounded-lg"
          >
            <inertia-link :href="`/admin/clients?status=${status.status}`" class="cursor-pointer text-blue-600 font-medium hover:underline">
              {{ statuses[status.status] }}<br />
              <strong class="text-lg text-gray-900">{{ status.count }}</strong>
            </inertia-link>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-1/3">
        <h2 class="w-full font-semibold text-center uppercase text-xl text-gray-700 mb-4">
          Benachrichtigungen
        </h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
          <inertia-link :href="'/admin/clients?notifications=service'" class="text-center p-4 bg-blue-50 border border-blue-200 rounded-lg cursor-pointer text-blue-600 font-medium hover:underline">
            Service<br />
            <strong class="text-lg text-gray-900">{{ serviceNotificationsCount }}</strong>
          </inertia-link>
          <inertia-link :href="'/admin/clients?notifications=advisor'" class="text-center p-4 bg-blue-50 border border-blue-200 rounded-lg cursor-pointer text-blue-600 font-medium hover:underline">
            Berater<br />
            <strong class="text-lg text-gray-900">{{ advisorNotificationsCount }}</strong>
          </inertia-link>
          <inertia-link :href="'/admin/clients?notifications=quality'" class="text-center p-4 bg-blue-50 border border-blue-200 rounded-lg cursor-pointer text-blue-600 font-medium hover:underline">
            Quality<br />
            <strong class="text-lg text-gray-900">{{ qualityNotificationsCount }}</strong>
          </inertia-link>
          <!--          <inertia-link :href="'/admin/clients?user_id=' + $page.props.auth.user.id " class="text-center p-4 bg-blue-50 border border-blue-200 rounded-lg cursor-pointer text-blue-600 font-medium hover:underline">-->
          <!--            Mein-->
          <!--          </inertia-link>-->
        </div>
      </div>
    </div>

    <!-- Credit Statistics -->
    <div class="w-full mt-10 bg-white rounded-lg p-6">
      <h2 class="w-full font-semibold text-center uppercase text-xl text-gray-700 mb-4">Statistik der Kundenkredite</h2>
      <div
        v-for="(value) in creditValues"
        :key="value.min_value"
        class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4"
      >
        <div class="text-center p-6 bg-red-50 border border-red-200 rounded-lg">
          <span class="block font-semibold text-gray-700">Mindestwert</span>
          <strong class="text-lg text-gray-900">{{ value.min_value }}</strong>
        </div>
        <div class="text-center p-6 bg-yellow-50 border border-yellow-200 rounded-lg">
          <span class="block font-semibold text-gray-700">Durchschnittlicher Wert</span>
          <strong class="text-lg text-gray-900">{{ Math.round(value.avg_value * 100) / 100 }}</strong>
        </div>
        <div class="text-center p-6 bg-green-50 border border-green-200 rounded-lg">
          <span class="block font-semibold text-gray-700">Maximalwert</span>
          <strong class="text-lg text-gray-900">{{ value.max_value }}</strong>
        </div>
      </div>
    </div>
    <div class="w-full mt-10 bg-white rounded-lg p-6">
      <h2 class="w-full font-semibold text-center uppercase text-xl text-gray-700 mb-4">Empfehlungsquellen:</h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
        <div
          v-for="url in clientUrlsComputed"
          :key="url.referential_url"
          class="text-center p-4 bg-blue-50 border border-blue-200 rounded-lg"
        >
          <inertia-link :href="`/admin/clients?search=${url.referential_url}`" class="cursor-pointer text-blue-600 font-medium hover:underline">
            {{ sources[url.referential_url] }}<br />
            <strong class="text-lg text-gray-900">{{ url.count }}</strong>
          </inertia-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import statuses from '../Clients/statuses'
import sources from '../Clients/sources'

export default {
  layout: Layout,
  props: {
    clientStatuses: Array,
    clientUrls: Array,
    creditValues: Array,
    advisorNotificationsCount: Number,
    serviceNotificationsCount: Number,
    qualityNotificationsCount: Number,
  },
  data() {
    return {
      statuses,
    }
  },
  computed: {
    sources() {
      return sources
    },
    clientUrlsComputed() {
      return this.clientUrls.filter((url) => url.referential_url).sort((a, b) => b.count - a.count)
    },
  },
  metaInfo: { title: 'Dashboard' },
}
</script>
